import { find, transform, omit, set, forEach } from 'lodash';

export const getBaseUrl = (isBarber, isBrand) => {
  if (isBrand) {
    return '/brand/settings/taxes';
  }

  if (isBarber) {
    return '/barber/settings/taxes';
  }

  return '/settings/taxes';
};

export const getInitialValuesFromTax = (tax) => {
  const initialValues = omit(tax, ['assignments', 'taxable']);

  forEach(tax.taxable, ({ id, deleted, type }) => {
    set(initialValues, `${type}s[${id}]`, !deleted);
  });

  return initialValues;
};

export const filterUnchangedAssignments = (formValues, initialTax) => ({
  ...formValues,
  shops: transform(formValues.shops, (memo, shop, ownerId) => {
    const { enabled = false, percentage } = shop;
    const prevAssignment = find(initialTax.assignments, { ownerId });
    const wasEnabled = !!prevAssignment;

    if (wasEnabled !== enabled) {
      set(memo, ownerId, {
        ...prevAssignment,
        ownerId,
        enabled,
        percentage: percentage === formValues.percentage ? null : percentage,
      });
    }

    if (wasEnabled && enabled && percentage !== prevAssignment.percentage) {
      set(memo, ownerId, { ...prevAssignment, enabled, percentage });
    }

    return memo;
  }, {}),
});

export default {};
